import React from 'react';
import Chart from 'react-apexcharts';

interface IData {
  x: any;
  y: any;
}

interface IProps {
  data: Array<IData>;
  options: any;
}

const HeatmapChart: React.FC<IProps> = React.memo(({ data, options }) => {
  return (
    <>
      <Chart
        options={{
          chart: {
            type: 'heatmap',
          },
          animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150,
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350,
            },
          },
          yaxis: {
            title: {
              text: 'Day of Week',
            },
            axisBorder: {
              show: false,
            },
            labels: {
              show: true,
            },
            axisTicks: {
              show: false,
            },
            max: 1,
            tickAmount: 7,
          },
          xaxis: {
            title: {
              text: 'Hour',
            },
            axisBorder: {
              show: false,
            },
            labels: {
              show: true,
            },
            axisTicks: {
              show: false,
            },
            min: 0,
            max: 23,
            tickAmount: 23,
          },
          dataLabels: {
            enabled: false,
          },
          ...options,
        }}
        series={data}
        type="heatmap"
        height={320}
      />
    </>
  );
});

HeatmapChart.displayName = 'HeatmapChart';

export default HeatmapChart;
